module.exports = __webpack_public_path__ + "img/warning_bigger.16400d10.svg";